import { useEffect, useState } from "react";
import logo from '../../assets/tools-icon.jpg';
import "./Navbar.scss"
import { FaRedo } from 'react-icons/fa';
import React from "react";
import { CoreValuesService } from "../../Services/CoreValuesService";
import { navbarData, navbarViewModel } from "./Navbar.ViewModel";
import { BehaviorSubject } from "rxjs";
import HamburgerMenu from "../hamburger-menu/HamburgerMenu";

interface NavbarProps {
    dataSubject: BehaviorSubject<navbarData>;
}

const Navbar: React.FC<NavbarProps> = ({ dataSubject }) => {
    const [viewModel, setViewModel] = useState<navbarViewModel>(new navbarViewModel(new navbarData()));

    useEffect(() => {
        dataSubject.subscribe((data) => {
            var vm = new navbarViewModel(data);
            setViewModel(vm)
        });
    }, [dataSubject]);

    let versionNumber = CoreValuesService.appVersion;
    let env = process.env.REACT_APP_ENVIRONMENT ?? "";

    return(
        <nav className="navbar-items">
            <a className="menu-button-wrapper" href={"/"} target="">
                <HamburgerMenu/>
            </a>
            <div className="titleContainer">
                <label className="nav-title"><b>{viewModel.title}</b></label>
                <div className="subtitleContainer">
                <label className="nav-subtitle"><b>{viewModel.subtitle}</b></label>
                <label className={getEnvironmentStyle(env)}>{getEnvironmentName(env)}</label>
                <label className="nav-version"><b>Release {versionNumber}</b></label>
                </div>
            </div>
        <div className="reloadContainer" onClick={e => window.location.reload()}>
            <FaRedo className="reload"/>
        </div>
        </nav>
    )
}

function getEnvironmentName(environment: string) {
    switch(environment) {
        case "local":
            return "Local";
        case "dev":
            return "Develop";
        case "test":
            return "Test";
        case "prod":
            return "Live";
        default:
            return "Unknown";
    }
}

function getEnvironmentStyle(environment: string) {
    switch(environment) {
        case "local":
            return "env-local";
        case "dev":
            return "env-dev";
        case "test":
            return "env-test";
        case "prod":
            return "env-prod";
        default:
            return "env-unknown";
    }
}

export default Navbar;